<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.addRecertTitle | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="!isAnonymous ? data.sysText.cancel : data.sysText.close" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

@if (!isAnonymous) {
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="main-container main-container-not-last">
        <div class="column-container">
          <app-input-field
            [group]="form"
            [control]="form.controls.name"
            [icon]="'description'"
            [label]="data.sysText.name">
          </app-input-field>
          <app-date-field
            class="field"
            [control]="form.controls.warningDate"
            [label]="data.sysText.warningDate"
            [group]="form"
            [icon]="'calendar_today'">
          </app-date-field>
        </div>
        <div class="column-container">
          <app-date-field
            class="field"
            [control]="form.controls.dueDate"
            [label]="data.sysText.dueDate"
            [group]="form"
            [icon]="'calendar_today'">
          </app-date-field>
          <app-date-field
            class="field"
            [control]="form.controls.completedDate"
            [label]="data.sysText.completedDate"
            [group]="form"
            [icon]="'calendar_today'">
          </app-date-field>
        </div>
      </div>
      <div class="main-container main-container-last">
        <div class="row-container">
          <app-text-area
            [group]="form"
            [control]="form.controls.comments"
            [icon]="'comment'"
            [label]="data.sysText.comments">
          </app-text-area>
        </div>
      </div>
      <mat-expansion-panel class="info-panel remove-mat-expansion-panel-padding" (opened)="uploadDocsOpenState = true" (closed)="uploadDocsOpenState = false"
        [expanded]="uploadDocsOpenState">
        <mat-expansion-panel-header #sectionHeader>
          <mat-panel-title>
            <div class="section-header-container">
              <p class="overline grey1 semibold section-title">{{data.sysText.recertDocuments | uppercase}}
              </p>
              <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-content">
          <div class="upload-button-container">
            <button
              type="button"
              (click)="uploadDocument()"
              mat-flat-button
              color="accent"
              class="button">
              {{data.sysText.uploadDoc}}
            </button>
          </div>
          @if (documents?.length > 0) {
            <div [ngClass]="{ 'make-scroll': !(isMobile$ | async) }" class="table-container">
              <table
                mat-table
                [dataSource]="_docs"
                [trackBy]="trackByDocument"
                id="data-table">
                <!-- Document Title Column -->
                <ng-container matColumnDef="documentTitle">
                  <th mat-header-cell *matHeaderCellDef>
                    <span>{{ data.sysText.documentTitle | titlecase }}</span>
                  </th>
                  <td mat-cell *matCellDef="let doc" [ngClass]="{ smaller: (isMobile$ | async) }">
                    <span>{{ doc.documentTitle | getdocext: doc.document.name}}</span>
                  </td>
                </ng-container>
                <!-- Document Category Column -->
                <ng-container matColumnDef="documentCategory">
                  <th mat-header-cell *matHeaderCellDef>
                    <span>{{ data.sysText.documentCategory | titlecase }}</span>
                  </th>
                  <td mat-cell *matCellDef="let doc" [ngClass]="{ smaller: (isMobile$ | async) }">
                    <span>{{ doc.documentCategoryId | findfromid: data.addRecertDialog.documentCategories }}</span>
                  </td>
                </ng-container>
                <!-- Comments Column -->
                <ng-container matColumnDef="documentComments">
                  <th mat-header-cell *matHeaderCellDef>
                    <span>{{ data.sysText.documentComments | titlecase }}</span>
                  </th>
                  <td
                    class="comments"
                    mat-cell
                    *matCellDef="let doc"
                    [ngClass]="{ smaller: (isMobile$ | async) }">
                    <span>{{ doc.documentComments }}</span>
                  </td>
                </ng-container>
                <!--Icons Column -->
                <ng-container matColumnDef="icons" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let doc" [ngClass]="{ smaller: (isMobile$ | async) }" class="mat-cell-action-buttons">
                    <div class="icons">
                      <button type="button" class="button-reset" [attr.aria-label]="data.sysText.delete_ariaLabel" (click)="clearDocument(doc)">
                        <mat-icon class="button-icon">delete</mat-icon>
                      </button>
                      <button type="button" class="button-reset" [attr.aria-label]="data.sysText.edit_ariaLabel" (click)="editDocument(doc)">
                        <mat-icon class="button-icon">edit</mat-icon>
                      </button>
                      @if ((hasDocErrors$ | async) && docHasError(doc)) {
                        <app-status-chip
                          [icon]="'error_outline'"
                          [removeMargin]="true"
                          [ngStyle]="chipStyles.warnBg"
                          [tooltip]="docErrorMessage(doc)">
                        </app-status-chip>
                      }
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </form>
  </mat-dialog-content>
} @else {
  <mat-dialog-content class="form-container">
    <p class="disallow">{{ data.sysText.caseRecerts_anonymousMessage }}</p>
  </mat-dialog-content>
}


<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ !isAnonymous ? data.sysText.cancel : data.sysText.close }}
    </button>
  }
  @if (!isAnonymous) {
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ data.sysText.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>
